import { render, staticRenderFns } from "./elmTable.vue?vue&type=template&id=ee5b999a&scoped=true&"
import script from "./elmTable.vue?vue&type=script&lang=js&"
export * from "./elmTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee5b999a",
  null
  
)

export default component.exports